import { useField } from 'formik';
import { useEffect } from 'react';
import { Box } from 'reflexbox';

import * as graphql from '@treams/treams-network';

import Group from './Group';
import GroupSelector from './GroupSelector';

export default function SingleGroupSelector(props: {
	groupID?: string;
	types?: graphql.GroupType[];
	required?: boolean;
	disabled?: boolean;
	onChange: (groupID?: string) => void;
	onLoad?: (groups: graphql.Group[]) => void;
	canSelect: (group: graphql.Group) => boolean;
}) {
	const groups = graphql.useGroupsQuery({
		variables: { first: 1000, filter: { types: props.types } },
	});

	useEffect(() => {
		if (!groups.data) {
			return;
		}

		const nodes = groups.data?.groups.edges.map(({ node }) => node as graphql.Group);
		props.onLoad?.(nodes);
	}, [!!groups.data]);

	if (!groups.data) {
		return (
			<Box mb={2}>
				<Group.Skeleton />
			</Box>
		);
	}

	const nodes = groups.data?.groups.edges.map(({ node }) => node as graphql.Group);

	return (
		<GroupSelector
			single
			required={props.required}
			disabled={props.disabled}
			types={props.types}
			initialGroups={nodes
				.filter(({ id }) => props.groupID === id)
				.map((group) => ({ group, recursive: false }))}
			canSelect={props.canSelect}
			onChange={(groups) => props.onChange(groups[0]?.id)}
		/>
	);
}

SingleGroupSelector.Formik = function SingleGroupSelectorFormik(props: {
	name: string;
	types?: graphql.GroupType[];
	required?: boolean;
	disabled?: boolean;
	onLoad?: (groups: graphql.Group[]) => void;
	canSelect: (group: graphql.Group) => boolean;
}) {
	const [{ value }, , { setValue }] = useField(props.name);

	return (
		<SingleGroupSelector
			groupID={value}
			types={props.types}
			required={props.required}
			disabled={props.disabled}
			onChange={setValue}
			onLoad={props.onLoad}
			canSelect={props.canSelect}
		/>
	);
};
